import React, { Suspense, useRef } from 'react'
import styled from 'styled-components'
import { Modal } from 'components/common/modal'
import { useDashboardStartupDetail, useStartupUser } from 'apis/hooks'
import { BaseText, SemiBoldText } from 'components/common/text'
import { Column } from 'components/common/layout'
import { useStores } from 'stores/globals'
import { DashboardStartupStore } from 'stores/dashboard/dashboard-startup'
import { DashboardStartupDetail, StartupUser } from 'types/common'
import { ServiceSelector } from 'components/misc/selector/service-selector'
import { observer } from 'mobx-react'
import { Button } from 'components/common/button'
import { requestToast } from 'components/common/toast'
import { mutate } from 'swr'

const DEPLOYED_AT = '2025-03-14T20:10:00+09:00'

export const ServiceAreaUpdateRequestModal: React.FC = observer(() => {
  const { loginStore } = useStores()
  const { data: startup } = useDashboardStartupDetail()
  const { data: user } = useStartupUser()

  if (loginStore.isFake || !startup?.isPublished || !user) return null
  const isScoutRequestUpdatedAfterReleaseDate =
    new Date(startup.updatedAt).getTime() > new Date(DEPLOYED_AT).getTime()
  if (isScoutRequestUpdatedAfterReleaseDate) return null
  return (
    <Suspense>
      <Content startup={startup} user={user} />
    </Suspense>
  )
})

const Content: React.FC<{
  startup: DashboardStartupDetail
  user: StartupUser
}> = observer(({ startup, user }) => {
  const store = useRef(new DashboardStartupStore(startup, user)).current
  return (
    <Modal width={500} disableCloseBtn disableBackgroundClick>
      <Column style={{ position: 'relative', gap: 40, padding: 24 }}>
        <Column style={{ gap: 8, textAlign: 'center' }}>
          <MainText>{startup.name}의 서비스 분야를 확인해주세요</MainText>
          <SubText>{`기업 정보에 서비스 분야가 추가되었어요!\n현재 입력된 서비스 분야를 확인하고, 원하신다면 수정해주세요`}</SubText>
        </Column>
        <ServiceSelector
          selectedServiceAreas={store.startup.serviceAreas}
          toggleServiceArea={(item) => store.toggleServiceArea(item)}
        />
        <Bottom>
          <Button
            onClick={async () => {
              try {
                await requestToast(store.save(), {
                  loading: '저장중',
                  success: '서비스 분야가 저장되었습니다.',
                })
                mutate('/dashboard/startup')
              } catch (e) {
                alert(e)
              }
            }}
          >
            확인
          </Button>
        </Bottom>
      </Column>
    </Modal>
  )
})

const MainText = styled(SemiBoldText)`
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.h5};
  }
  font-size: ${(p) => p.theme.fontSize.h4};
`

const SubText = styled(BaseText)`
  @media ${(p) => p.theme.deviceSize.desktop} {
    font-size: ${(p) => p.theme.fontSize.desc};
  }
  line-height: 1.5;
  color: ${(p) => p.theme.color.black4};
`

const Bottom = styled(Column)`
  position: sticky;
  bottom: 24px;
  left: 0;
  width: 100%;
`
